import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['togglable', 'required'];

  toggle(event) {
    if (this._meetsVisibilityCondition(event.target.value)) {
      this._showChildren();
    } else {
      this._hideChildren();
    }
  }

  _meetsVisibilityCondition(value) {
    return this.matchers.includes(value);
  }

  _showChildren() {
    this.togglableTargets.forEach(target =>
      target.classList.remove('u-is-hidden')
    );

    this.requiredTargets.forEach(target => target.setAttribute('required', ''));
  }

  _hideChildren() {
    this.togglableTargets.forEach(target =>
      target.classList.add('u-is-hidden')
    );

    this.requiredTargets.forEach(target => target.removeAttribute('required'));
  }

  get matchers() {
    return this.data.get('matchers').split('|');
  }
}
